import { defineWebModule } from '@nexus/core-web';
import { de } from '../i18n/de';
import { en } from '../i18n/en';
import { manifest } from '../manifest';

// Public web API for other modules (docs/architecture/base-modules.md).
export { contactRefsQuery, organizationRefsQuery, organizationSearchQuery } from './api';
export { ContactLink, ContactPicker, type ContactPickerProps } from './contact-picker';
export {
  OrganizationLink,
  OrganizationPicker,
  type OrganizationPickerProps,
} from './organization-picker';
/** `data` of the records in the offline source `crm.organization`. */
export type { OrganizationDetails, PostalAddress } from '../types';

/** Listed in apps/web/src/modules.ts. Pages load on first visit, each module is its own bundle. */
export const webModule = defineWebModule({
  manifest,
  messages: { de, en },
  pages: [
    {
      path: '/crm/organizations',
      load: () => import('./organizations-page'),
      permission: 'crm.organization.read',
    },
    {
      path: '/crm/map',
      load: () => import('./map-page'),
      permission: 'crm.organization.read',
    },
    {
      path: '/crm/organizations/$id',
      load: () => import('./organization-page'),
      permission: 'crm.organization.read',
    },
    {
      path: '/crm/contacts',
      load: () => import('./contacts-page'),
      permission: 'crm.contact.read',
    },
    {
      path: '/crm/contacts/$id',
      load: () => import('./contact-page'),
      permission: 'crm.contact.read',
    },
  ],
  guides: [
    {
      id: 'crm.organizations',
      title: 'crm.guides.organizations.title',
      summary: 'crm.guides.organizations.summary',
      pages: ['/crm/organizations', '/crm/organizations/$id'],
      content: {
        de: () => import('./guides/organizations.de.md?raw'),
        en: () => import('./guides/organizations.en.md?raw'),
      },
    },
    {
      id: 'crm.contacts',
      title: 'crm.guides.contacts.title',
      summary: 'crm.guides.contacts.summary',
      pages: ['/crm/contacts', '/crm/contacts/$id', '/crm/organizations/$id'],
      content: {
        de: () => import('./guides/contacts.de.md?raw'),
        en: () => import('./guides/contacts.en.md?raw'),
      },
    },
  ],
});
